const groupStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'SUSPENDED', name: 'Suspended' }
];

export { groupStatus };
